import apiClient from '../client';

export interface PatternFormData {
  requestDate: string;
  patternReceivedDate: string;
  digitizedDate: string;
  dateSentToCutter: string;
  patternType: string;
  patternToMadeBy: string;
  year: string;
  make: string;
  model: string;
  submodel: string;
  body: string;
  partNumber: string;
  seatType: string;
  seatPosition: string;
  seatOptions: string[];
  additionalOptions: string;
  approvedBy: string;
  approvalDate: string;
}

export const patternRequestService = {
  submitPatternRequest: async (data: PatternFormData): Promise<{ success: boolean; message: string }> => {
    const response = await apiClient.post('/pattern-requests/submit', data);
    return response.data;
  },
};
